// extracted by mini-css-extract-plugin
export default {"wrapper":"s_bT","textWrapper":"s_bV"};